import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contains',
    standalone: false,
})
export class ArrayContainsPipe implements PipeTransform {
    transform(array: null | any[], value: any): boolean {
        return (array ?? []).includes(value);
    }
}
